// Configure the Back button href
$(".card a.btn").attr("href", document.referrer);
